// extracted by mini-css-extract-plugin
module.exports = {"backButton":"Wizard_backButton__1Uzre Inputs_input__3H5nv"};